import { GeohashMap } from '@/components/GeohashMap';

function Index() {
  return <GeohashMap />;
}

export default Index;
